import { LOCKS, MESSAGES } from './copy';
import {
  LAST_ROLE_CODE,
  SELF_MODIFICATION_CODE,
  toAccessErrors,
} from './serverErrors';

describe('toAccessErrors', () => {
  it('is empty for an empty envelope', () => {
    expect(toAccessErrors()).toEqual({ base: [], byAccount: {} });
  });

  it('keys per-account messages by the account id in the dotted path', () => {
    const mapped = toAccessErrors({
      'accounts.4711': ['Something went wrong'],
    });

    expect(mapped.byAccount).toEqual({ 4711: ['Something went wrong'] });
    expect(mapped.base).toEqual([]);
  });

  it('collects anything that is not an account under base', () => {
    const mapped = toAccessErrors({ base: ['Not permitted'] });

    expect(mapped.base).toEqual(['Not permitted']);
    expect(mapped.byAccount).toEqual({});
  });

  it('speaks the tooltip sentence for a self-modification refusal', () => {
    const mapped = toAccessErrors(
      {
        'accounts.4711': ["Modifications to the requesting user's own access"],
      },
      { 'accounts.4711': [SELF_MODIFICATION_CODE] },
    );

    expect(mapped.byAccount['4711']).toEqual([LOCKS.selfModify]);
  });

  it('points a last-role refusal at Remove Access', () => {
    const mapped = toAccessErrors(
      { 'accounts.4711': ['The last role assignment cannot be removed'] },
      { 'accounts.4711': [LAST_ROLE_CODE] },
    );

    expect(mapped.byAccount['4711']).toEqual([LOCKS.lastRole]);
  });

  it('falls back to the server sentence for a code it has no wording for', () => {
    const mapped = toAccessErrors(
      { 'accounts.4711': ['Role is not available for this account.'] },
      { 'accounts.4711': ['decisiv:account_users:999'] },
    );

    expect(mapped.byAccount['4711']).toEqual([
      'Role is not available for this account.',
    ]);
  });

  it('falls back to a generic when the server sent neither', () => {
    const mapped = toAccessErrors({ 'accounts.4711': [''] });

    expect(mapped.byAccount['4711']).toEqual([MESSAGES.generic]);
  });

  it('matches the pluralized codes the glossary actually emits', () => {
    expect(SELF_MODIFICATION_CODE).toBe('decisiv:account_users:003');
    expect(LAST_ROLE_CODE).toBe('decisiv:account_users:002');
  });
});
